<template>
  <div>
    <!-- QUIENES SOMOS -->
    <Titles :viewport="viewport" scene="earlyTitle">
      <div class="row row-cdiv" style="display: flex; flex-flow: row wrap; z-index: 99">
        <div class="col-md-6-b" style="width: 100%; margin-top: -5%; position: relative">
          <div class="div-qs-c">
            <p class="title-column title-black" style="text-align: center">
              Somos una empresa enfocada en entregar soluciones efectivas para problemas tecnologicos que
              presente tu negocio y además de servicios que lo impulsa. Contamos con partners estratégicos con
              años de experiencia que nos permite que las soluciones entregadas, sean soluciones integrales,
              efectivas y ajustadas a tus necesidades. <br />
              ¡Escríbenos y conversemos!
            </p>
          </div>
        </div>
      </div>
    </Titles>

    <Titles :viewport="viewport" scene="earlyTitle2">
      <section class="social-grid titulo-servicios">
        <div class="container-b">
          <div class="row" style="width: 100%">
            <div class="col-lg-12 col-xl-1 fade-in-right visible" style="height: 100vh">
              <h2 class="title--3xl title--stroke title--vertical">Servicios</h2>
            </div>
            <div class="col-lg-12 col-xl-10" style="display: none">
              <div class="flex-grid flex-grid--social fade-in-up visible"></div>
            </div>
          </div>
        </div>
      </section>

      <div class="icon-scroll" style="top: 50%"></div>
    </Titles>

    <Titles :viewport="viewport" scene="earlyTitle3"> </Titles>

    <!-- SERVICIOS -->
    <div class="scene_" id="early-days">
      <div class="container-c">
        <div class="service-div">
          <!-- METODOLIGÍAS -->
          <h1>Metodologías</h1>
          <div class="container-c">
            <img src="../../assets/img/proceso.png" alt="" class="img-proceso" />
          </div>

          <h1>Servicios</h1>
          <div class="timeline" style="margin-bottom: 50px">
            <div class="timeline-item">
              <div class="timeline-date">
                <div>Administración TI</div>
              </div>
              <div class="timeline-content">
                <h2>Ciberseguridad</h2>
                <li>Distributed Denial of Service (DDos)</li>
                <li>Ethical Hacking</li>
                <br />
                <i class="fa fa-shield" aria-hidden="true"></i>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">
                <div>Ingeniería TI</div>
              </div>
              <div class="timeline-content">
                <h2>Web Stress</h2>
                <p>
                  Es una prueba de carga en la cual simulamos un número determinado de visitas para saber el
                  comportamiento del sitio donde te asesoraremos, a través de un análisis exhaustivo,
                  entregando recomendaciones para que tu sitio funcione sin problemas.
                </p>
                <br />
                <i class="fa fa-globe" aria-hidden="true"></i>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">
                <div>Desarrollo de Software</div>
              </div>
              <div class="timeline-content">
                <h2>Fixed scoped</h2>
                <p>
                  Construímos software a medida a partir de una definición de producto. Este servicio
                  contempla un scope y planificación fijos, definidos al inicio del proyecto.
                </p>
                <br />
                <h2>Células Ágiles</h2>
                <p>
                  Equipos de desarrollo con dedicación mensual exclusiva. Este servicio contempla una célula
                  en modalidad Time & Materials, flexible ante cambios en el proyecto.
                </p>
                <br />
                <i class="fa fa-desktop" aria-hidden="true"></i>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">
                <div>Áreas de conocimiento</div>
              </div>
              <div class="timeline-content">
                <h2>Desarrollo web</h2>
                <p>Diseño y construcción de Aplicaciones en la nube para uso en navegadores web.</p>
                <br />
                <h2>Infraestructura y Devops</h2>
                <p>Diseño de arquitectura, configuración y mantención de ambientes en la nube con CI/CD.</p>
                <p>Migración a la nube.</p>
                <br />
                <h2>Diseño UI & UX</h2>
                <p>Maquetación gráfica de Interfaces de Usuario y diseño de Experiencias Digitales.</p>
                <br />
                <h2>Transformación digital</h2>
                <p>
                  Facilitamos la incorporación de soluciones tecnológicas a productos, servicios, procesos y
                  estrategias de las organizaciones (Digitalización de procesos, Migración a la nube).
                </p>
                <br />
                <h2>Integración de sistemas</h2>
                <p>
                  Conectamos (integramos) sistemas, subsistemas y/o elementos de estos para que actúen como
                  uno solo.
                </p>
                <br />
                <h2>Transformación digital</h2>
                <p>
                  Facilitamos la incorporación de soluciones tecnológicas a productos, servicios, procesos y
                  estrategias de las organizaciones.
                </p>

                <br />
                <i class="fa fa-clipboard service-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SLIDER SERVICIOS -->
      <div>
        <div class="social-grid2">
          <h2
            class="title--3xl title--stroke title--stroke3 title--vertical"
            style="letter-spacing: -1px; padding-top: 100px; padding-bottom: 30px"
          >
            Aplicaciones
          </h2>
        </div>
        <div class="container-customx" style="display: flex; flex-flow: row wrap">
          <div class="description clearfix">
            <img class="logo_servicio" src="../../assets/img/logo_servicio1.png" />

            <p class="title-pp light"><b>SMS 8i</b></p>

            <div class="excerpt">
              <p>
                ¡Te ayudamos a impulsar tu negocio! Plataforma enfocada al servicio de Mensajeria de Texto
                SMS. <br />
                Generamos envíos masivos de mensajes de texto a telefono moviles para campañas de Marketing,
                cobranza, promociones, claves, confirmaciones y mucho mas!.
              </p>
              <br />
            </div>
          </div>

          <div id="anim" class="desktop screenshot transition-slow img-s anim-1"></div>
        </div>

        <div
          class="container-customx mb-customf"
          style="display: flex; flex-flow: row wrap; margin-top: 100px"
        >
          <div class="description clearfix">
            <!-- <img class="logo_servicio" src="../../assets/img/logo_servicio2.png" /> -->

            <p class="title-pp light"><b>Octolance</b></p>

            <div class="excerpt">
              <p>
                ¡Proximamente! Una plataforma web enfocada en los Freelancers y sus servicios. <br />
                El Objetivo es facilitar la gestión de los proyectos a los freelancers, para un mejor control
                de los clientes, desarrollo, cotizaciones, cuentas por cobrar y pagos, y mejorar la
                comunicación con el cliente por sistemas de mensajería y repositorio de información.
              </p>
              <br />
            </div>
          </div>

          <div id="anim" class="desktop screenshot transition-slow img-s anim-2"></div>
        </div>
      </div>
    </div>

    <!-- FORMULARIO CONTACTO -->
    <div class="social-grid">
      <div class="container-b">
        <div class="row" style="width: 100%">
          <div class="col-lg-12 col-xl-1 fade-in-right visible">
            <h2 class="title--2xl title--stroke2 title--vertical">Contáctanos</h2>
          </div>
          <div class="col-lg-12 col-xl-10" style="display: none">
            <div class="flex-grid flex-grid--social fade-in-up visible"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="get-in-touch" style="z-index: 999">
      <!-- <h1 class="title" style="overflow-wrap: normal;">Trabaja con nosotros!</h1> -->
      <form ref="form" @submit.prevent="submit" class="contact-form row">
        <div class="df-div">
          <div class="group group-c" style="margin: 10px 14px">
            <span class="text-field">Nombre</span>
            <input type="text" name="nombre" v-model="form.nombre" size="40" />
            <span class="line"></span>
          </div>
          <div class="group group-c" style="margin: 10px 14px">
            <span class="text-field">E-mail</span>
            <input type="email" name="email" v-model="form.email" value="" size="40" />
            <span class="line"></span>
          </div>
        </div>

        <div class="group" style="margin: 10px 14px; width: 100%">
          <span class="text-field">Mensaje</span>
          <input type="text" name="mensaje" v-model="form.mensaje" value="" size="40" />
          <span class="line"></span>
        </div>

        <div class="col-md-12 mb-4">
          <vue-recaptcha ref="recaptcha" id="recaptcha" @verify="onVerify" :sitekey="token"></vue-recaptcha>
        </div>

        <div class="form-field col x-100 align-center form-field2">
          <button
            type="submit"
            id="sumbit"
            :disabled="form.nombre == '' || form.email == '' || form.mensaje == '' || !form.robot"
          >
            <p>Hablemos!</p>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              enable-background="new 0 0 512 512"
              xml:space="preserve"
            >
              <path
                id="paper-plane-icon"
                d="M462,54.955L355.371,437.187l-135.92-128.842L353.388,167l-179.53,124.074L50,260.973L462,54.955z
                      M202.992,332.528v124.517l58.738-67.927L202.992,332.528z"
              ></path>
            </svg>
          </button>
        </div>
      </form>

      <div class="sticky-img" style="position: relative; top: 180px">
        <div id="container">
          <div class="steam" id="steam1"></div>
          <div class="steam" id="steam2"></div>
          <div class="steam" id="steam3"></div>
          <div class="steam" id="steam4"></div>

          <div id="cup">
            <div id="cup-body">
              <div id="cup-shade"></div>
            </div>
            <div id="cup-handle"></div>
          </div>

          <div id="saucer"></div>

          <div id="shadow"></div>
        </div>
      </div>
    </div>

    <!-- NUESTROS CLIENTES -->
    <div class="container-c" style="margin-top: 200px; margin-bottom: 90px; z-index: 40">
      <div class="row justify-content-center py-3">
        <div class="col-md-8 col-12 text-center">
          <h1 class="title-white margin-only-desktop" style="margin-bottom: 90px; line-height: 1.3">
            Nuestros Clientes
          </h1>
        </div>
      </div>

      <ul class="section-clients__list" style="display: flex; place-content: center">
        <li>
          <img src="../../assets/partners/ihosting.png" alt="" />
        </li>
        <li>
          <img src="../../assets/partners/worki.png" alt="" />
        </li>
        <li>
          <img src="../../assets/partners/martech.png" alt="" />
        </li>
      </ul>
    </div>

    <section class="scene" id="early-days2" style="z-index: 30; min-height: 1px"></section>
  </div>
</template>

<script>
import Titles from "./Titles.vue";
import FormError from "@/components/Home/FormError";
import { onlyNumber } from "@/helpers";
import VueRecaptcha from "vue-recaptcha";
import { VueAgile } from "vue-agile";
import axios from "axios";
import emailjs from "emailjs-com";
export default {
  name: "EarlyDays",
  components: {
    VueRecaptcha,
    Titles,
    FormError,
    agile: VueAgile,
  },
  props: {
    viewport: Object,
  },
  data: () => ({
    verify: false,
    send: false,
    form: {
      nombre: "",
      email: "",
      mensaje: "",
      robot: false,
    },
    token: process.env.VUE_APP_API_RECAPTCHA_TOKEN,
  }),
  watch: {
    "form.nombre"(val) {
      if ($("#sumbit").hasClass("clicked") && val !== "") {
        $("#sumbit").toggleClass("clicked");
        $("button p").text(function (i, text) {
          return text === "Enviado!" ? "Enviar" : "Enviado!";
        });
      }
    },
  },

  methods: {
    onlyNumber,
    submit(e) {
      $("#sumbit").toggleClass("clicked");
      $("button p").text(function (i, text) {
        return text === "Enviado!" ? "Enviar" : "Enviado!";
      });
      try {
        emailjs.sendForm("service_wt90ngq075ftf", "template_vnkwm8n", e.target, "user_ZZLGBeQJERQzJuaYsy9Hn");

        this.form = {
          nombre: "",
          email: "",
          mensaje: "",
          robot: false,
        };
        this.$toast.success("Mensaje enviado! Te contactaremos a la brevedad.");

        setTimeout(() => {
          if ($("#sumbit").hasClass("clicked")) {
            $("#sumbit").toggleClass("clicked");
            $("button p").text(function (i, text) {
              return text === "Enviado!" ? "Enviar" : "Enviado!";
            });
          }
        }, 9000);
      } catch (error) {
        console.log({ error });
        this.$toast.error("Error al intentar enviar el mensaje.");
      }
    },

    clearForm: function () {
      this.form.nombre = "";
      this.form.email = "";
      this.form.telefono = "";
      this.form.asunto = "";
      this.form.robot = false;

      let index = this.motivos.findIndex((item) => item.motivo == this.form.motivo);
      this.form.mensaje = this.motivos[index].plantilla;

      this.$nextTick(() => {
        this.errors.clear();
        this.$nextTick(() => {
          this.$validator.reset();
        });
      });
    },
    onVerify: function (response) {
      if (response) {
        this.form.robot = true;
        this.form["g-recaptcha-response"] = response;
      }
    },
    resetRecaptcha() {
      this.verify = false;
      this.robot = false;
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
  },
};
</script>
